import { Link } from "react-router-dom";
import { Button } from "../../components/ui/button";
import { SERVICES } from "../../lib/constants";
import { ArrowRight, Check } from "lucide-react";

export const PageHero = ({ overline, title, sub }) => (
  <section className="bg-[#08080A] text-white relative overflow-hidden">
    <div className="absolute inset-0" style={{ background: "radial-gradient(ellipse at 80% 0%, rgba(0,122,255,0.15), transparent 50%)" }} />
    <div className="max-w-7xl mx-auto px-5 lg:px-8 py-20 lg:py-28 relative z-10">
      <p className="overline-cc mb-4 fade-up">{overline}</p>
      <h1 className="font-heading font-extrabold text-4xl sm:text-5xl lg:text-6xl tracking-tight fade-up-1">{title}</h1>
      {sub && <p className="mt-5 text-white/60 max-w-2xl leading-relaxed fade-up-2">{sub}</p>}
    </div>
  </section>
);

const DETAILS = {
  moving: ["Local flat-rate moves (studio to 5BR+)", "Long distance: San Diego ⇄ LA ⇄ Las Vegas", "Full packing & unpacking available", "Furniture disassembly & reassembly included"],
  white_glove_delivery: ["Premium white-glove handling", "Room-of-choice placement or threshold drop-off", "Fragile & high-value item specialists", "Scheduled delivery windows, not all-day waits"],
  furniture_assembly: ["Assemble or disassemble any furniture", "Flat-pack, office, and modular systems", "Wall mounting & anchoring", "Tools, hardware, and cleanup included"],
  junk_removal: ["We'll get rid of it — big or small", "Donation routing first, dump is the last option", "Same-day hauls available", "Upfront volume-based flat pricing"],
  labor: ["Loading & unloading crews", "Event setup and breakdown", "On-site heavy lifting teams", "Hourly crews with a minimum guarantee"],
};

export default function Services() {
  return (
    <div>
      <PageHero overline="Capabilities" title="Services engineered for precision."
        sub="Every service runs on the same operating system: vetted crews, flat-rate pricing, mission-grade planning, and real-time tracking." />
      <section className="max-w-7xl mx-auto px-5 lg:px-8 py-20 space-y-6">
        {SERVICES.map((s, i) => (
          <div key={s.id} data-testid={`service-detail-${s.id}`} className="card-lift rounded-xl border bg-card p-8 lg:p-10 grid lg:grid-cols-12 gap-8 items-start">
            <div className="lg:col-span-5">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-xl bg-[var(--cc-accent)]/10 flex items-center justify-center shrink-0">
                  <s.icon className="w-5 h-5 text-[var(--cc-accent)]" />
                </div>
                <div>
                  <p className="font-mono-cc text-[10px] tracking-[0.25em] text-muted-foreground uppercase">Division 0{i + 1}</p>
                  <h2 className="font-heading font-bold text-2xl">{s.name}</h2>
                </div>
              </div>
              <p className="text-muted-foreground mt-4 leading-relaxed">{s.blurb}</p>
              <p className="mt-4 font-mono-cc text-xs text-muted-foreground">FROM <span className="text-foreground font-semibold text-base">{s.from}</span></p>
            </div>
            <ul className="lg:col-span-5 space-y-3">
              {DETAILS[s.id].map((d) => (
                <li key={d} className="flex items-start gap-3 text-sm">
                  <Check className="w-4 h-4 text-[var(--cc-accent)] mt-0.5 shrink-0" /> {d}
                </li>
              ))}
            </ul>
            <div className="lg:col-span-2 flex lg:justify-end">
              <Link to="/quote" state={{ service: s.id }}>
                <Button data-testid={`service-quote-button-${s.id}`} className="rounded-full btn-glow bg-[var(--cc-accent)] text-black hover:bg-[var(--cc-accent)]/90 font-semibold">
                  Get Quote <ArrowRight className="w-4 h-4 ml-1" />
                </Button>
              </Link>
            </div>
          </div>
        ))}
      </section>
    </div>
  );
}
